import React from 'react';
import { useTranslation } from 'react-i18next';

const VideoSection: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-slate-900/50 video-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-white mb-4">
            {t('landing.video_section.title')}
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
            {t('landing.video_section.subtitle')}
          </p>
        </div>
        
        <div className="relative">
          <div className="bg-slate-800 rounded-3xl p-2 shadow-lg border border-slate-700">
            <div className="aspect-video rounded-2xl overflow-hidden">
              <iframe
                src="https://www.youtube.com/embed/TMlBHOvj7-c?rel=0&modestbranding=1&showinfo=0"
                title={t('landing.video_section.iframe_title')}
                className="w-full h-full rounded-2xl"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;